module.exports = __webpack_public_path__ + "assets/img/gar5-8.5cf99439.jpg";